import {invisiblyApi} from "../api/invisibly-api";
import {Survey, SurveyJSON} from "../survey/survey.types";
import {GenerateSurveyFormValues} from "../../pages/generate-survey/generate-survey.types";
import {InvisiblyApiResponse} from "../../services/api/api-response.types";
import SurveyService from "../../services/surveys/survey.service";
import {surveyEndpoints} from "../survey/survey.endpoints";
import { AiServiceTrigger } from "./ai.types";
import { showLoadingNotification } from "../notification/notification.slice";
import axios from "axios";
import { apiUrl } from "src/constants/config";

const aiEndpoints = invisiblyApi.injectEndpoints({
  endpoints: (builder) => ({
    generateAiSurvey: builder.mutation<Survey, { template_id: string; formData: GenerateSurveyFormValues }>({
      queryFn: async({ template_id, formData }) => {
        try {
          // Directly use axios in order to properly override default 30s timeout
          const response = await axios.post<InvisiblyApiResponse<SurveyJSON>>(
            `${apiUrl}/b2b/templates/${template_id}/generate`,
            formData,
            { timeout: 60000 }
          );
          return { data: SurveyService.parseListSurvey(response.data.item) };
        } catch (error: any) {
          return { error: error.response ? error.response.data : error.message };
        }
      },
      async onQueryStarted(_arg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          const ext_survey_id = data.extSurveyId;

          dispatch(
            surveyEndpoints.util.updateQueryData('getSurvey', { ext_survey_id }, (draft) => {
              Object.assign(draft, data);
            })
          );
        } catch (error) {
          console.error('Error generating survey:', error);
        }
      },
    }),
    generateService: builder.mutation<AiServiceTrigger, { ext_survey_id: string, service: string }>({
      query: ({ ext_survey_id, service }) => ({
        data: {ext_survey_id, service},
        method: 'post',
        url: 'ai/b2b/trigger',
      }),
      transformResponse: (response: InvisiblyApiResponse<AiServiceTrigger>) => {
        return {
          extSurveyId: response.item.extSurveyId,
          service: response.item.service,
        };
      },
      async onQueryStarted({ ext_survey_id, service }, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          if (!data) {
            return;
          }

          let id = "";

          if (service === "summary") {
            id = "summary_notification_id";
          }

          dispatch(showLoadingNotification({
            id: id,
            summary: "trigger",
            theme: "info",
          }));

          dispatch(
            surveyEndpoints.util.updateQueryData('getSurveySummary', { ext_survey_id }, (draft) => {
              Object.assign(draft, data);
            })
          );
        } catch (error) {
          console.error('Error creating media plan', error);
        }
      },
    }),
  }),
  overrideExisting: true,
});

export const { useGenerateAiSurveyMutation, useGenerateServiceMutation } = aiEndpoints;
export { aiEndpoints };
